
<template>
    <v-row>
      <v-col>
        <div class="container">
         <a><img id="imageEng" v-bind:class="{imgEnglish:englishClass}" src="@/assets/EN-unactive.png" v-on:click="switchLocale('en')"></a>
         <a><img v-bind:class="{imgJapan:japanClass}"  src="@/assets/ja-unactive.png" v-on:click="switchLocale('ja')"></a>
         <!-- <button id="a" v-on:click="switchLocale('en')"><img v-bind:class="{imgEnglish:englishClass}" src="@/assets/EN-unactive.png"></button>
         <button id="b" v-on:click="switchLocale('ja')"><img v-bind:class="{imgJapan:imgJapan}" src="@/assets/ja-unactive.png"></button> -->
        </div>
      </v-col>
    </v-row>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: 'SelectLanguage',
  data:function() {
      return { 
          currentLocale: '',
          englishClass: false,
          japanClass: true,
        }
  },
  methods: { 
    ...mapMutations({
      setSelectedLanguage: "homeData/setSelectedLanguage",
    }),
    switchLocale(locale) {
      this.setSelectedLanguage(locale);
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.currentLocale = locale;
        if(locale == 'en') {
          this.englishClass = true;
          this.japanClass = false;
        } else {
          this.japanClass = true;
          this.englishClass = false;
        }
      }
    }
  },
  created() {
      this.currentLocale = this.$i18n.locale;
      if(this.currentLocale == 'en') {
        this.englishClass = true;
        this.japanClass = false;
      } else {
        this.japanClass = true;
        this.englishClass = false;
      }
  },
}
</script>
<style scoped>
img{
  width: 41px;
  height: 23px;
}
.imgJapan{
  border: 1px groove;
  opacity: 1.0;
  background-image: url('../../assets/ja-active.png');
}
.imgEnglish{
  border: 1px groove #f1bd42;
   background-image: url('../../assets/EN-active_login.png');
  opacity: 1.0;
}
#imageEng{
   margin-right: 5px;
}
button:focus {outline:0;}
</style>
